// A class to handle the opening and closing of accordions. Key bindings, aria attributes and instantiation are all handled.
export class Accordion {
  constructor (elem) {
    this.elem = elem
    this.panels = elem.querySelectorAll('details')
    this.allowMultiple = elem.hasAttribute('data-allow-multiple')
    this.setupEvents()
  }

  setupEvents () {
    for (const panel of this.panels) {
      const summary = panel.querySelector('summary')

      summary.addEventListener('click', () => {
        if (!this.isOpen(panel) && !this.allowMultiple) {
          this.closeOthers(panel)
        }
      })

      summary.addEventListener('keydown', (event) => {
        const key = event.which.toString()
        if (key.match(/38|40|35|36/)) {
          switch (key) {
            // Home key
            case '36':
              this.focusPanel(0)
              break
            // End key
            case '35':
              this.focusPanel(this.panels.length - 1)
              break
            // ArrowUp key
            case '38':
              this.focusPanel(this.getPanelIndex(panel) - 1)
              break
            // ArrowDown key
            case '40':
              this.focusPanel(this.getPanelIndex(panel) + 1)
              break
          }
          event.preventDefault()
        }
      })
    }
  }

  getPanelIndex (panel) {
    return Array.prototype.indexOf.call(this.panels, panel)
  }

  focusPanel (index) {
    if (index < this.panels.length && index >= 0) {
      const panel = this.panels[index]
      const summary = panel.querySelector('summary')
      summary.focus()
    }
  }

  isOpen (panel) {
    return panel.hasAttribute('open')
  }

  closeOthers (panel) {
    for (const pnl of this.panels) {
      if (pnl !== panel) {
        pnl.removeAttribute('open')
      }
    }
  }
}

export const setupAccordions = function (parent) {
  const elems = parent.querySelectorAll('.accordion')

  const accordions = []

  for (const elem of elems) {
    accordions.push(new Accordion(elem))
  }

  return accordions
}
